import BaseEulaField from 'registration/js/base/fields/eula';

import template from 'registration/templates/simple/fields/eula.html';

const EulaField = BaseEulaField.extend({
    template
});

export default EulaField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/simple/fields/eula.js